export default {
  RESET_STORE(state) {
    Object.assign(state, {
      ...state,
      selectedGroup: null,
      selectedGroupsIds: [],
      allGroupsIds: [],
      currentPageFacilitiesGroups: [],
      groupsTotalCount: 0,
      currentPageSelectedGroupFacilities: [],
      selectedGroupSelectedFacilities: [],
      allSelectedGroupFacilitiesIds: [],
      selectedGroupFacilitiesTotalCount: 0
    });
  },

  SET_SELECTED_GROUP: (state, payload) => {
    state.selectedGroup = payload;
  },

  SET_SELECTED_GROUPS_IDS: (state, payload) => {
    state.selectedGroupsIds = payload;
  },

  SET_ALL_GROUPS_IDS: (state, payload) => {
    state.allGroupsIds = payload;
  },

  SET_CURRENT_PAGE_FACILITIES_GROUPS: (state, payload) => {
    state.currentPageFacilitiesGroups = payload;
  },

  SET_GROUPS_TOTAL_COUNT: (state, payload) => {
    state.groupsTotalCount = payload;
  },

  SET_CURRENT_PAGE_SELECTED_GROUP_FACILITIES: (state, payload) => {
    state.currentPageSelectedGroupFacilities = payload;
  },

  SET_SELECTED_GROUP_SELECTED_FACILITIES: (state, payload) => {
    state.selectedGroupSelectedFacilities = payload;
  },

  SET_ALL_SELECTED_GROUP_FACILITIES_IDS: (state, payload) => {
    state.allSelectedGroupFacilitiesIds = payload;
  },

  SET_SELECTED_GROUP_FACILITIES_TOTAL_COUNT: (state, payload) => {
    state.selectedGroupFacilitiesTotalCount = payload;
  }
};
